body.modal-open {
    overflow: hidden;
}

.modal-overlay {
    // display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transform: translateX(-100%);
    // z-index: 320;
    // transform: scale(0.25);
    // transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    transition: all 0.25s linear;
    overflow: hidden;
    z-index: -110;

    &.is-visible {
        z-index: 320;
        opacity: 1;
        transform: translateX(0);
    }

    .modal-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        background-color: rgba(#270634, 0.85);
    }

    .modal-content {
        width: 100%;
        height: 100%;
        padding: 60px 0;
        overflow-y: auto;
        overflow-x: hidden;

        .inner {
            flex-grow: 1;
            width: 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
        }
    }
}

// ----- header search modal ----- //
.modal-overlay#header-search {
    transform: none;
    transition: opacity 0.25s linear, transform 0.25s linear;

    &.is-visible {
        .header-search-contents {
            transform: translateY(0);
        }
    }

    .modal-content {
        padding-top: 0;
        padding-bottom: 0;

        .inner {
            align-items: flex-start;
            justify-content: flex-start;
        }
    }

    .modal-close {
        display: none;
        margin-left: 16px;
        padding-left: 13px;
        padding-right: 13px;
    }

    .header-search-contents {
        width: 100%;
        box-shadow: $light-drop-shadow;
        background-color: $core-neutral-100;
        padding-top: 14px;
        padding-bottom: 14px;
        transform: translateY(-100%);
        transition: transform 0.25s linear 0.25s;

        .main-contents {
            display: flex;
            align-items: center;
            flex-direction: row;
            max-width: 720px;
            margin-left: auto;
            margin-right: auto;
        }

        .header-search-form {
            flex-grow: 1;

            .ac-search-container {
                max-width: none;

                .auto-complete-container {
                    .search-results {
                        height: 0;
                        max-height: calc(100vh - 250px);
                        max-height: calc(var(--vh, 1vh) * 100 - 250px);
                        transition: height 0.25s linear;
                        box-shadow: $heavy-drop-shadow;

                        .result-item p {
                            margin-top: 0;

                            // .highlight {
                            //     color: white;
                            //     background-color: $colour-highlight;
                            //     padding: 0.3rem 0.3rem 0.1rem;
                            // }
                        }
                    }
                }
            }

            .result-count-container {
                line-height: 1.5;
                padding: 16px 24px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;

                .secondary-button.small {
                    flex-shrink: 0;
                    padding-left: 1.6rem;
                    padding-right: 1.6rem;
                }
            }

            .popular-suggests {
                padding: 32px;
                background-color: $core-neutral-100;
            }

            .title-text {
                display: block;
                font-weight: 700;

                // .highlight {
                //     color: white;
                //     background-color: $colour-highlight;
                //     padding: 0.3rem 0.3rem 0.1rem;
                // }

                &.no-result-text {
                    display: flex;
                    flex-direction: row;
                }
            }

            .icon-search-error {
                width: 2.4rem;
                height: 2.4rem;
                margin-right: 1rem;
            }
        }
    }

    @include min(1024px) {
        .header-search-contents {
            padding-top: 24px;
            padding-bottom: 24px;
        }
    }
}